import BaseStore from './BaseStore';
import _ from 'lodash';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

const defaultData = [];
export class AcknowledgeStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      data: _.cloneDeep(defaultData),
    });
  }

  getItemLocal(key) {
    return Promise.resolve().then(function () {
      return localStorage.getItem(key);
    });
  }

  async setPermission(groups) {
    let groupPermission = localStorage.getItem('group_permission');
    groupPermission = groupPermission !== 'undefined' ? JSON.parse(groupPermission) : [];
    let subGroupPermission = localStorage.getItem('subgroup_permission');
    subGroupPermission = subGroupPermission !== 'undefined' ? JSON.parse(subGroupPermission) : [];
    if (groupPermission.length === 1) {
      groupPermission.forEach((data) => {
        localStorage.setItem('select_group', data);
        const group = groups.find((item) => item.id === data);
        if (group) {
          if (subGroupPermission.length === 1 || group.subGroups.length === 1) {
            const subGroup = group.subGroups.find((sub) => sub.id === subGroupPermission[0]);
            if (subGroup) {
              localStorage.setItem('select_module', JSON.stringify([subGroupPermission[0]]));
              localStorage.setItem('subgroup_type', subGroup.type || 'hospital');
            }
          }
        }
      });
    }
  }

  async getAcknowledge() {
    try {
      if (localStorage.getItem('select_tenant')) {
        const data = {
          limit: 5,
          // tenants: [JSON.parse(localStorage.getItem('select_tenant'))],
        };

        if (localStorage.getItem('select_module')) {
          data['subgroups'] = JSON.parse(localStorage.getItem('select_module'));
        }
        const res = await rp
          .post(`${config.api.url}/${config.api.version}/acknowledge/subgroup`, {
            body: data,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          const acknowledge = res.body || [];
          this.data = acknowledge;
        }
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    }
  }

  setRead() {
    this.data.map((val) => (val.unRead = false));
  }

  async addAcknowledge(data) {
    const newData = [...this.data];
    const duplicate = await this.checkDuplicateData(data);
    if (!duplicate) {
      newData.unshift(data);

      if (newData.length > 5) {
        newData.pop();
      }
    }

    this.data = newData;
  }

checkDuplicateData = async (data) => {
  const [newNotification] = data.notification;

  return this.data.some((val) =>
    val.notification.some(
      (noti) =>
        noti.timestamp === newNotification.timestamp &&
        noti.deviceId === newNotification.deviceId
    )
  );
};
}

export default new AcknowledgeStore();
